const STATUS = {
  OPEN: { value: 'OPEN', label: 'Open' },
  CLOSED: { value: 'CLOSED', label: 'Closed' }
};

const STATUSES = Object.values(STATUS);

export { STATUSES, STATUS };
